export enum BROWSER_NAMES {
	CHROME = 'chrome',
	EDGE = 'edge',
	CHROMIUM_EDGE = 'chromium_edge',
	FIREFOX = 'firefox',
	IE = 'ie',
	SAFARI = 'safari',
	MOBILE_SAFARI = 'mobile safari'
}
